import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { DnvLegendState } from 'dnv-lib';


@Component({
    selector: 'app-dnv-metadata',
    templateUrl: './dnv-metadata.component.html',
    styleUrls: ['./dnv-metadata.component.scss'],
    standalone: false
})
export class DnvMetadataComponent implements OnInit {
  // tslint:disable-next-line: variable-name
  private _contentHeight: number;
  metaExpand = '';

  @Input() legendState: DnvLegendState = null;
  // @Input() set contentHeight(value: number){
  //   this._contentHeight = value;
  // }

  // get contentHeight(): number{
  //   return this._contentHeight;
  // }

  constructor() { }

  ngOnInit(): void {

  }

  toggleMetaContent(name: string): void {
    if (this.metaExpand === name) {
      this.metaExpand = '';
    } else {
      this.metaExpand = name;
    }
  }
}
